module.exports = __webpack_public_path__ + "files/resume.pdf";